module.exports = __webpack_public_path__ + "img/img2.dddc25c4.png";